module.exports = __webpack_public_path__ + "img/US_WeaponRange_ua.e5623304.webp";